// extracted by mini-css-extract-plugin
export default {"logo":"HeaderLogo_logo__F2KX6","label":"HeaderLogo_label__GlSt6","knowledgePlay":"HeaderLogo_knowledgePlay__B7VXn"};